import React from "react";
import { Link } from "react-router-dom";
import { Star, Plus } from "lucide-react";
import { useCart } from "../context/CartContext";
import { toast } from "sonner";

const ProductCard = ({ product }) => {
  const { addItem } = useCart();

  const handleAdd = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!product.inStock) return;
    addItem(product, 1);
    toast.success("Added to cart", { description: product.name });
  };

  return (
    <Link to={`/product/${product.slug}`} className="group block card-hover bg-[#141210] rounded-lg overflow-hidden border border-[#2c2822]">
      <div className="relative overflow-hidden aspect-[4/5] bg-gradient-to-b from-[#f6f1e7] to-[#e4dccb]">
        <img src={product.image} alt={product.name} className="img-zoom w-full h-full object-contain p-6" />

        {product.badge && (
          <span className="absolute top-4 left-4 bg-[#c9a24b] text-[#0b0a09] text-[10px] tracking-[0.15em] uppercase px-3 py-1 rounded-full font-medium">
            {product.badge}
          </span>
        )}
        {!product.inStock && (
          <span className="absolute top-4 right-4 bg-[#1b1815]/90 border border-[#2c2822] text-[#a29a8c] text-[10px] tracking-[0.15em] uppercase px-3 py-1 rounded-full">
            Sold Out
          </span>
        )}

        <button
          onClick={handleAdd}
          disabled={!product.inStock}
          className={`absolute bottom-4 right-4 w-11 h-11 rounded-full flex items-center justify-center transition-all duration-400 translate-y-3 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 ${
            product.inStock ? "btn-gold" : "bg-[#1b1815] text-[#6b6459] cursor-not-allowed"
          }`}
          aria-label="Add to cart"
        >
          <Plus size={20} />
        </button>
      </div>

      <div className="p-5">
        <div className="flex items-center gap-1 mb-2">
          <Star size={13} className="fill-[#c9a24b] text-[#c9a24b]" />
          <span className="text-[#a29a8c] text-xs">{product.rating} · {product.reviews} reviews</span>
        </div>
        <h3 className="font-display text-xl text-[#f4efe4] leading-snug group-hover:text-[#c9a24b] transition-colors">
          {product.name}
        </h3>
        <p className="text-[#a29a8c] text-xs mt-1 line-clamp-1">{product.tagline}</p>
        <div className="flex items-center gap-2 mt-3">
          <span className="text-[#c9a24b] text-lg font-display">${product.price.toFixed(2)}</span>
          {product.compareAt && (
            <span className="text-[#6b6459] text-sm line-through">${product.compareAt.toFixed(2)}</span>
          )}
        </div>
      </div>
    </Link>
  );
};

export default ProductCard;
